import * as yup from 'yup'

export const fieldNames = ['teachesLessons', 'yearsTeaching']

export const validationSchema = yup.object().shape({
  teachesLessonsAnswer: yup.string().required('This field is required'),
  yearsTeaching: yup.string().required('This field is required'),
})

export const generateContext = (
  courseName,
  siteId,
  claims,
  programTrack,
  programName,
) => {
  return {
    sites: [
      {
        siteId,
        claims,
        programs: {
          [programName]: {
            courses: [
              {
                name: courseName,
                version: null,
              },
            ],
            preferences: {
              programTrack,
            },
          },
        },
      },
    ],
  }
}
